import { render, staticRenderFns } from "./CrudModal.vue?vue&type=template&id=037b5b10"
import script from "./CrudModal.vue?vue&type=script&lang=js"
export * from "./CrudModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports